import React, { useImperativeHandle, useMemo, useRef } from "react";
import { validateFields } from "utils/form/validate";

const FormSection = ({ validationRef, children, scheme }) => {
  const dataRef = useRef(scheme);
  const fieldRefs = useMemo(() => {
    const _data = dataRef.current;
    if (!_data) {
      return {};
    }

    return Object.keys(_data).reduce(
      (fields, key) => ({ ...fields, [key]: React.createRef() }),
      {}
    );
  }, [dataRef]);

  const isFormComponent = (name) => !!fieldRefs[name];

  const childrenArray = Array.isArray(children) ? children : [children];

  useImperativeHandle(validationRef, () => ({
    validate: () => !validateFields([...Object.values(fieldRefs)]),
    updateField: (fieldName, { errorMessage, value }) => {
      if (errorMessage) {
        fieldRefs[fieldName].current.setError(errorMessage);
      } else {
        fieldRefs[fieldName].current.updateValue(value);
      }
    },
    getData: () =>
      Object.keys(fieldRefs).reduce((data, key) => {
        data[key] = fieldRefs[key]?.current?.getData();
        return data;
      }, {}),
  }));

  return childrenArray?.map((child, index) => {
    let formChild = child;
    if (isFormComponent(child?.props?.name)) {
      formChild = React.cloneElement(child, {
        ...child.props,
        initialValue: scheme[child.props.name],
        validationRef: fieldRefs[child.props.name],
      });
    }
    return <React.Fragment key={index}>{formChild}</React.Fragment>;
  });
};

export default FormSection;
